// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ColumnWidthOutlinedSvg from "@ant-design/icons-svg/es/asn/ColumnWidthOutlined";
import AntdIcon from '../components/AntdIcon';

var ColumnWidthOutlined = function ColumnWidthOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ColumnWidthOutlinedSvg
  }));
};

ColumnWidthOutlined.displayName = 'ColumnWidthOutlined';
export default React.forwardRef(ColumnWidthOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ColumnWidthOutlined.js
// module id = 837
// module chunks = 0